<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button slot="title" type="warning" class="dropdown-toggle">
                    Audit Reports - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    Audit Reports
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <!-- <img style="display: none;" id='reportLogo' :src="imagepath" alt='Report Logo' crossorigin="anonymous"/> -->
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col" v-if="currentProfile == 'admin_group_reports'">
                    <AdminGroupReports :access_rights="accessRights"></AdminGroupReports>
                </div>
                <div class="col" v-if="currentProfile == 'user_access_reports'">
                    <UserAccessReports :access_rights="accessRights"></UserAccessReports>
                </div>
                <div class="col" v-if="currentProfile == 'user_group_access_reports'">
                    <UserGroupAccessReports :access_rights="accessRights"></UserGroupAccessReports>
                </div>
                <div class="col" v-if="currentProfile == 'user_activity_reports'">
                    <UserActivityReports :access_rights="accessRights"></UserActivityReports>
                </div>
                <div class="col" v-if="currentProfile == 'failed_user_login_reports'">
                    <FailedUserLoginReports :access_rights="accessRights"></FailedUserLoginReports>
                </div>
                <div class="col" v-if="currentProfile == 'wavelet_access_reports'">
                    <WaveletAccessReports :access_rights="accessRights"></WaveletAccessReports>
                </div>
                <div class="col" v-if="currentProfile == 'pos_site_terminal_reports'">
                    <PosSiteTerminalReports :access_rights="accessRights"></PosSiteTerminalReports>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AdminGroupReports from './AdminGroupReport.vue';
    import UserActivityReports from './UserActivityReport.vue';
    import UserAccessReports from './UserAccessReport.vue';
    import UserGroupAccessReports from './UserGroupAccessReport.vue';
    import FailedUserLoginReports from './FailedUserLoginReport.vue';
    import WaveletAccessReports from './WaveletAccessReport.vue';
    import PosSiteTerminalReports from './PosSiteTerminalReport.vue'

    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                activeModules: [],
                accessRights: [],
                imagepath: secureStorage.getItem("account_logo")
            }
        },
        components: {
            AdminGroupReports,
            UserAccessReports,
            UserGroupAccessReports,
            UserActivityReports,
            FailedUserLoginReports,
            WaveletAccessReports,
            PosSiteTerminalReports,
        },
        mounted: async function () {
            var component_x = this;
            
            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF

            var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?code=AUDREP&status=A', null, null)
            if(categoryId[0] != undefined){
                component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)
                if (component_x.activeModules.length > 0) {
                    var profile = _.snakeCase(component_x.activeModules[0].name)
                    component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
                } else {
                    component_x.setCurrentProfile(null, null);
                }
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }
                this.updateCurrentProfile(profile);
            }
        }
    };
</script>

<style></style>